import React, { useEffect, useContext } from 'react';
import { Context } from '../../../context/context';
import Image from 'next/image';
import { imagesWEBP } from '../../../constants/webpImages';

const LeadGenSuccessPopup = () => {
    const state = useContext(Context);
    const { hideLeadGenSuccessPopup } = useContext(Context);
  useEffect(() => {
    if (state.openLeadGenSuccessPopup) {
      const timer = setTimeout(() => {
        hideLeadGenSuccessPopup();
      }, 3000); 

      return () => clearTimeout(timer); 
    }
  }, [hideLeadGenSuccessPopup, state.openLeadGenSuccessPopup]);

  if (!state.openLeadGenSuccessPopup) return null;

  return (
    <div className="fixed inset-0 w-screen h-screen bg-black/30 flex justify-center items-center z-[1000]">
      <div className="bg-white rounded-lg w-[90%] max-w-[400px] md:max-w-[520px] p-5 md:p-8 text-center relative shadow-lg">
        <button 
          className="absolute top-0 right-0 bg-transparent border-none text-2xl md:text-3xl cursor-pointer px-5 py-2.5 md:px-6 md:py-3" 
          onClick={hideLeadGenSuccessPopup}
        >
          &times;
        </button>
        <div className="pt-2.5 md:pt-4 flex flex-col items-center">
          <Image 
            src={imagesWEBP.successIcon} 
            alt="Success" 
            width={50} 
            height={50}
            className="w-[60px] md:w-[80px] h-auto mb-4 md:mb-6" 
          />
          <h2 className="m-0 mb-2.5 md:mb-3 text-black text-center font-inter text-base md:text-xl font-semibold leading-normal">
            Thank you!
          </h2>
          <p className="m-0 text-black text-center font-inter text-sm md:text-base font-medium leading-normal">
            Our team will reach out to you shortly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LeadGenSuccessPopup;

